import Page from '@components/common/Page'
import Link from '@components/common/Link'
import NftInfoTable from '@components/common/NftInfoTable'
import FAQ from '@components/faq/FAQ'
import { Heading, Title, Typography, Divider } from '@jeromevvb/equinox-lib'
import RichTextBlock from '@models/projects/interfaces/richText.interface'

interface FaqProps {
  faqs: {
    question: string
    answer: RichTextBlock
  }[]
}

const HowToParticipatePage = ({ faqs }: FaqProps) => {
  return (
    <Page
      title="How to participate"
      description="Pick your NFT and be part of the Equinox community"
    >
      <div className="container">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-24">
          <Heading size="large" weight="semibold" className="mb-6">
            How to participate
          </Heading>
          <Typography size="large">
            Pick your NFT and be part of the Equinox community
          </Typography>
        </div>
        <NftInfoTable />
        <div className="mb-24">
          <Typography size="medium">
            Please note that you will need to confirm your participation before
            the particiption window closes.{' '}
            <Link
              size="medium"
              underline
              weight="medium"
              href="https://intercom.help/equinox/en/articles/5771973-how-can-i-confirm-my-participation"
              external
            >
              How to confirm my participation?
            </Link>
          </Typography>
        </div>
        <div className="mb-36">
          <div className="grid lg:grid-cols-12 lg:gap-x-8 mb-10">
            <Title size="medium" weight="semibold" className="col-span-5">
              Guaranteed allocation
            </Title>
            <Typography className="col-span-6">
              Your allocation is guaranteed.
            </Typography>
          </div>

          <div className="mb-10">
            <Divider horizontal />
          </div>

          <div className="grid lg:grid-cols-12 lg:gap-x-8 mb-10">
            <Title size="medium" weight="semibold" className="col-span-5">
              Lottery/FCFS
            </Title>
            <Typography className="col-span-6">
              If you win, you will have a guaranteed allocation in the winner
              pool. <br /> However, if you don’t win the lottery, you will get
              access to the first come first served pool (usually called FCFS
              Pool). Be quick!
            </Typography>
          </div>

          <div className="mb-10">
            <Divider horizontal />
          </div>

          <div className="grid lg:grid-cols-12 lg:gap-x-8 mb-10">
            <Title size="medium" weight="semibold" className="col-span-5">
              FCFS (First Come, First Served)
            </Title>
            <Typography className="col-span-6">
              You need to be quick in order to get your allocation. This system
              is usually used when we offer unsold tokens to our NFT holders or
              in the case you didn’t win the lottery.
            </Typography>
          </div>

          <div className="mb-10">
            <Divider horizontal />
          </div>

          <div className="grid lg:grid-cols-12 lg:gap-x-8 mb-10">
            <Title size="medium" weight="semibold" className="col-span-5">
              Lottery
            </Title>
            <Typography className="col-span-6">
              If you win, you will have a guaranteed allocation.
            </Typography>
          </div>
        </div>
        <FAQ faqs={faqs} />
      </div>
    </Page>
  )
}

export default HowToParticipatePage
